/***
 * 创建人：段锐
 * 时间：2019-06-11
 * 描述：音频播放
 * 使用说明: 参考 sw-audio 配置应用说明文档
 * 更新说明:
 */
import { Input, Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from '../sw-modal-frame/sw-modal-frame.component';
declare var $: any;

/**
 * 音频播放  sw-audio
 * @ignore
 */
@Component({
  selector: 'sw-audio',
  templateUrl: './sw-audio.component.html',
  styleUrls: ['./sw-audio.component.css']
})
export class SwAudioComponent implements OnInit {

  /**
   * @ignore
   */
  constructor() { }


  /**
   * 文件名称
   */
  @Input() title: string = "";


  /**
   * 文件绝对路径
   */
  @Input() src: string;

  /**
   * @ignore
   */
  @Output() voted = new EventEmitter(); //销毁组建事件

  /**
   * 播放状态，false-->暂停 ， true-->播放
   * @ignore
   */
  playStatus:boolean = false

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('audioModal') audioModal: SwModalframeComponent; 

  /**
   * @ignore
   */
  ngOnInit() {
  }

  /**
   * 打开音频方法
   * @ignore
   */
  openAudio() {
    //this.voted.emit(true);   
    $(".audioBox").removeClass("hidden");
  }

  /**
   * 关闭音频方法
   * @ignore
   */
  closeAudio() {
    this.voted.emit(true)
  }

  //播放
  play(event){
    this.playStatus = true
  }

  //暂停
  pause(event){
    this.playStatus = false

  }

  //倍速播放
  ratechange(event){
    this.playStatus = true

  }

  //点击关闭模态框
  close(){
    this.audioModal.toggle() //关闭模态框
  }
}
